<!--header-right-->
<template>
  <div class="home-banner">
    <van-swipe class="my-swipe" :style="{height: `calc(36.5vw - 8.76px)`}" :stop-propagation="false" autoplay="3000" indicator-color="#fff">
      <van-swipe-item v-for="(item, index) in banners" :key="index">
        <van-image class="vant-image" width="100%" height="100%" :src="item.PicUrl" @click="$emit('delegate', index)">
          <img slot="error" style="width: 100%;height: 100%" :src="require('@/assets/image/base/hotel_error.png')">
        </van-image>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    banners: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.home-banner
  width 100%
  border-radius 12px
  margin-bottom 12px
  >.my-swipe
    width 100%
    background-color $color_black_0
    border-radius 12px
    .vant-image
      width 100%
      height 100%
      background-repeat no-repeat
      background-size 24px 24px
      background-position center
</style>
